export const dashArray = 250;
export const dashOffset = 250;
export const lineAnimDuration = 1000;
export const lineAnimDelay = 250;
export const circleAnimDuration = 100;
export const circleAnimDelay = 0;